import { render, staticRenderFns } from "./ProwebBookingStub.vue?vue&type=template&id=1bdb9e9c&scoped=true&"
import script from "./ProwebBookingStub.vue?vue&type=script&lang=js&"
export * from "./ProwebBookingStub.vue?vue&type=script&lang=js&"
import style0 from "./ProwebBookingStub.vue?vue&type=style&index=0&id=1bdb9e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb9e9c",
  null
  
)

export default component.exports